const stuSmartPavilionAppointStatusNameMap = {
  0: '待赴约',
  10: '已取消',
  20: '未赴约',
  30: '已结束'
}

const stuSmartPavilionAppointStatusClassMap = {
  0: 'blue20',
  10: 'orange20',
  20: 'red20',
  30: 'green20',
};

// '-2': '别人预约',
//   '-3': '自己预约',
//   '-1': '不能预约',
//   '1': '当前选中'
const colorMap = {
  '-2': '#cbc565',
  '-3': '#88c061',
  '-1': '#e3e6ef',
  '1': '#3f9dfd'
};

export function getColor(value) {
  return colorMap[value] || 'initial'; // 如果没有匹配的值，则返回 'initial'
}

/**
 *
 * @param {Number} consult_SmartPavilion
 *    0: '待赴约',
 *   10: '已取消',
 *   20: '未赴约',
 *   30: '已结束'
 */
export function getStuSmartPavilionAppointStatusName(status) {
  return stuSmartPavilionAppointStatusNameMap[status] || '其他';
}

export function getStuSmartPavilionAppointStartTime(appoint) {
  let futureTimeString = appoint.appointDate + ' ' + appoint.startTime

  const diff = getRemainingTime(futureTimeString)
  // 如果差值小于0，说明时间已经过去
  if (diff < 0) {
    return '';
  }
  // 计算天、小时和分钟
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / 1000 / 60) % 60);
  // 返回剩余时间的字符串
  return appoint.status === 0 ? `开始还剩下 ${days}天${hours}小时${minutes}分钟` : "";
}

export function getRemainingTime(futureTimeString) {
  // 解析输入的时间字符串
  const futureTime = new Date(futureTimeString);
  // 获取当前时间
  const now = new Date();
  // 计算两个时间之间的差值
  return futureTime - now
}

export function getStuSmartPavilionAppointStatusClass(status) {
  return stuSmartPavilionAppointStatusClassMap[status] || '其他';
}


export function findContinuousTimeSlots(timeSlot) {
  let result = [];
  let startIndex = -1;

  for (let i = 0; i <= timeSlot.length; i++) {
    if (timeSlot[i] === 1 && startIndex === -1) {
      startIndex = i;
    } else if (timeSlot[i] !== 1 && startIndex !== -1) {
      // 添加时间区间到结果数组
      const startHour = String(startIndex < 10 ? '0' + startIndex : startIndex).padStart(2, '0');
      const endHour = String(i - 1 < 10 ? '0' + (i - 1) : i - 1).padStart(2, '0');
      result.push(`${startHour}:00-${endHour}:59`);
      startIndex = -1;
    }
  }
  // 将结果数组转换为字符串
  return result.length > 0 ? result.join(', ') : '无';
}


export function isShowKey(appoint) {
  const {status, appointDate, startTime, endTime} = appoint
  if (status === 10 || status === 20) {
    return false
  }
  if (status === 0) {
    return true
  }
  if (status === 30 && isCurrentTimeBetweenAppointment(appointDate, startTime, endTime)) {
    return true
  }
}

export function isCurrentTimeBetweenAppointment(appointDate, startTime, endTime) {
  const appointment = new Date(`${appointDate}T${startTime}`);
  const end = new Date(`${appointDate}T${endTime}`);
  // 获取当前时间
  const now = new Date();
  // 检查当前时间是否在给定的时间范围内
  return now >= appointment && now <= end;
}
